import TranslatedTextField from './component';
import { TranslatedTextFieldProps } from './types';

export type { TranslatedTextFieldProps };
export default TranslatedTextField;
